import {
  accountsBaseUrl,
  cloudBaseUrl,
  docsBaseUrl,
  hubBaseUrl,
  websiteBaseUrl,
} from '../constants/url';

const contactUsUrlObject = {
  pathname: `${websiteBaseUrl}/contact-us`,
  query: {},
};

export const paths = {
  accounts: {
    auth: {
      forgotPassword: `${accountsBaseUrl}/auth/forgot-password`,
      register: `${accountsBaseUrl}/auth/register`,
      resetPassword: `${accountsBaseUrl}/auth/reset-password`,
      verifyEmail: `${accountsBaseUrl}/auth/verify-email`,
    },
    index: accountsBaseUrl ? `${accountsBaseUrl}` : '/',
    success: `${accountsBaseUrl}/success`,
    successClose: `${accountsBaseUrl}/success-close`,
    successManual: `${accountsBaseUrl}/success-manual`,
  },
  awsMarketplace:
    'https://aws.amazon.com/marketplace/pp/prodview-lowyuyay5a37s?sr=0-1&applicationId=AWSMPContessa',
  bluesky: 'https://bsky.app/profile/cloudquery.bsky.social',
  careers: 'https://apply.workable.com/cloudquery',
  cloud: {
    auth: {
      connector: `${cloudBaseUrl}/auth/connector`,
      forgotPassword: `${cloudBaseUrl}/auth/forgot-password`,
      login: `${cloudBaseUrl}/auth/login`,
      register: `${cloudBaseUrl}/auth/register`,
      resetPassword: `${cloudBaseUrl}/auth/reset-password`,
      verifyEmail: `${cloudBaseUrl}/auth/verify-email`,
    },
    createTeam: `${cloudBaseUrl}/create-team`,
    index: cloudBaseUrl ? `${cloudBaseUrl}` : '/',
    packages: {
      addon: {
        index: `${cloudBaseUrl}/teams/$team/packages/addons/$type/$addon`,
        version: {
          index: `${cloudBaseUrl}/teams/$team/packages/addons/$type/$addon/versions/$version`,
        },
        versions: `${cloudBaseUrl}/teams/$team/packages/addons/$type/$addon/versions`,
      },
      addons: `${cloudBaseUrl}/teams/$team/packages/addons`,
      createAddon: `${cloudBaseUrl}/teams/$team/packages/create-addon`,
      createPlugin: `${cloudBaseUrl}/teams/$team/packages/create-plugin`,
      plugin: {
        index: `${cloudBaseUrl}/teams/$team/packages/plugins/$kind/$plugin`,
        version: {
          index: `${cloudBaseUrl}/teams/$team/packages/plugins/$kind/$plugin/versions/$version`,
        },
        versions: `${cloudBaseUrl}/teams/$team/packages/plugins/$kind/$plugin/versions`,
      },
      plugins: `${cloudBaseUrl}/teams/$team/packages/plugins`,
    },
    team: {
      apiKeys: `${cloudBaseUrl}/teams/$team/api-keys`,
      billing: `${cloudBaseUrl}/teams/$team/billing`,
      index: `${cloudBaseUrl}/teams/$team`,
      invitations: `${cloudBaseUrl}/teams/$team/invitations`,
      members: `${cloudBaseUrl}/teams/$team/members`,
      settings: `${cloudBaseUrl}/teams/$team/settings`,
      usage: {
        index: `${cloudBaseUrl}/teams/$team/usage`,
        plugin: {
          create: `${cloudBaseUrl}/teams/$team/usage/$pluginTeam/$pluginKind/$pluginName/limit/create`,
          update: `${cloudBaseUrl}/teams/$team/usage/$pluginTeam/$pluginKind/$pluginName/limit/update`,
        },
      },
    },
    teamShortLinks: {
      apiKeys: `${cloudBaseUrl}/team-api-keys`,
      billing: `${cloudBaseUrl}/team-billing`,
      destinations: {
        create: `${cloudBaseUrl}/team-destinations/create`,
      },
      invitations: `${cloudBaseUrl}/team-invitations`,
      members: `${cloudBaseUrl}/team-members`,
      settings: `${cloudBaseUrl}/team-settings`,
      sources: {
        create: `${cloudBaseUrl}/team-sources/create`,
      },
      syncs: {
        index: `${cloudBaseUrl}/team-syncs`,
      },
      usage: {
        index: `${cloudBaseUrl}/team-usage`,
      },
    },
    user: {
      index: `${cloudBaseUrl}/user`,
    },
    userSettings: {
      invitations: `${cloudBaseUrl}/user-settings/invitations`,
      settings: `${cloudBaseUrl}/user-settings/settings`,
    },
  },
  community: 'https://community.cloudquery.io',
  contactUs: contactUsUrlObject.pathname,
  contactUsUrlObject,
  deploymentOverview: `${docsBaseUrl}/managing-cloudquery/deployments/overview`,
  docs: {
    alerts: `${docsBaseUrl}/alerts`,
    cli: {
      index: docsBaseUrl ? `${docsBaseUrl}/platform/introduction` : '/platform/introduction',
    },
    createPlugin: `${docsBaseUrl}/cli/integrations/creating-new-integration`,
    dashboards: `${docsBaseUrl}/cli/core-concepts/dashboards`,
    howToGuides: `${websiteBaseUrl}/blog/category/tutorials`,
    index: docsBaseUrl ? `${docsBaseUrl}/platform/introduction` : '/platform/introduction',
    plugins: `${docsBaseUrl}/cli/core-concepts/integrations`,
    publishAddon: `${docsBaseUrl}/cli/advanced/publishing-an-addon-to-the-hub`,
    publishPlugin: `${docsBaseUrl}/cli/advanced/publishing-an-integration-to-the-hub`,
    quickstart: `${docsBaseUrl}/cli/getting-started`,
    roles: `${docsBaseUrl}/platform/production-deployment/user-management/workspace-roles-overview`,
    searchesAndQueries: `${docsBaseUrl}/cli/core-concepts/searches-and-queries`,
    syncs: `${docsBaseUrl}/cli/core-concepts/syncs`,
    transformations: `${docsBaseUrl}/cli/core-concepts/transformations`,
  },
  documentation: docsBaseUrl ? `${docsBaseUrl}/platform/introduction` : '/platform/introduction',
  github: 'https://github.com/cloudquery/cloudquery',
  githubIssues: 'https://github.com/cloudquery/cloudquery/issues',
  hub: {
    addon: `${hubBaseUrl}/addons/[type]/[team]/[name]`,
    addonDocs: `${hubBaseUrl}/addons/[type]/[team]/[name]/[version]/docs`,
    addonVersion: `${hubBaseUrl}/addons/[type]/[team]/[name]/[version]`,
    addonVersionDynamic: `${hubBaseUrl}/addons-dynamic/[type]/[team]/[name]/[version]`,
    addonVersions: `${hubBaseUrl}/addons/[type]/[team]/[name]/[version]/versions`,
    addons: `${hubBaseUrl}/addons/[type]`,
    exportData: `${hubBaseUrl}/export-data/[source]/[destination]`,
    exportDataPlatformSpecific: `${hubBaseUrl}/export-data/[source]/[destination]/[platform]`,
    plugin: `${hubBaseUrl}/plugins/[kind]/[team]/[name]`,
    pluginDestinations: `${hubBaseUrl}/plugins/[kind]/[team]/[name]/[version]/destinations`,
    pluginDestinationsWithoutVersion: `${hubBaseUrl}/plugins/[kind]/[team]/[name]/destinations`,
    pluginDocs: `${hubBaseUrl}/plugins/[kind]/[team]/[name]/[version]/docs`,
    pluginTable: `${hubBaseUrl}/plugins/[kind]/[team]/[name]/[version]/tables/[table]`,
    pluginTables: `${hubBaseUrl}/plugins/[kind]/[team]/[name]/[version]/tables`,
    pluginVersion: `${hubBaseUrl}/plugins/[kind]/[team]/[name]/[version]`,
    pluginVersionDynamic: `${hubBaseUrl}/plugins-dynamic/[kind]/[team]/[name]/[version]`,
    pluginVersions: `${hubBaseUrl}/plugins/[kind]/[team]/[name]/[version]/versions`,
    plugins: `${hubBaseUrl}/plugins/[kind]`,
    pluginsSource: `${hubBaseUrl}/plugins/source`,
    reportDetails: `${hubBaseUrl}/reports/[name]`,
    reports: `${hubBaseUrl}/reports`,
    reportsDynamic: `${hubBaseUrl}/reports-dynamic`,
    templates: `${hubBaseUrl}/templates`,
  },
  linkedIn: 'https://www.linkedin.com/company/cloudqueryio',
  noAccount: '/no-account',
  onboarding: '/onboarding',
  platform: {
    auth: {
      login: '/auth/login',
    },
    createTeam: `/create-team`,
    index: '/',
    settings: {
      account: {
        index: '/settings/account/profile',
        mfa: '/settings/account/mfa',
        profile: '/settings/account/profile',
      },
      organization: {
        apiKeys: '/settings/organization/api-keys',
        auditLogs: '/settings/organization/audit-logs',
        customColumns: '/settings/organization/custom-columns',
        dataPermissions: {
          create: '/settings/organization/data-permissions/create',
          edit: '/settings/organization/data-permissions/[id]',
          index: '/settings/organization/data-permissions',
        },
        featureFlags: '/settings/organization/feature-flags',
        index: '/settings/organization/settings',
        integrations: '/settings/organization/integrations',
        members: '/settings/organization/members',
        notificationDestinations: '/settings/organization/notification-destinations',
        roles: {
          create: '/settings/organization/roles/create',
          edit: '/settings/organization/roles/[id]',
          index: '/settings/organization/roles',
        },
        settings: '/settings/organization/settings',
        sso: '/settings/organization/sso',
        updates: '/settings/organization/updates',
        users: '/settings/organization/users',
      },
    },
    team: {
      assetInventory: {
        index: `/teams/[team]/asset-inventory`,
        syntax: `/teams/[team]/asset-inventory/syntax`,
      },
      index: `/teams/[team]`,
      policies: {
        create: `/teams/[team]/policies/create`,
        detail: `/teams/[team]/policies/[id]`,
        index: `/teams/[team]/policies`,
      },
      reports: {
        index: `/teams/[team]/reports`,
        report: `/teams/[team]/reports/[id]`,
      },
      sqlConsole: {
        index: `/teams/[team]/sql-console`,
      },
      syncs: {
        create: `/teams/[team]/syncs/create`,
        destinations: {
          create: `/teams/[team]/syncs/destinations/create`,
          index: `/teams/[team]/syncs/destinations`,
          syncs: `/teams/[team]/syncs/destinations/[name]/syncs`,
          update: `/teams/[team]/syncs/destinations/[name]/update`,
        },
        index: `/teams/[team]/syncs`,
        runs: {
          index: `/teams/[team]/syncs/[name]/runs`,
        },
        sources: {
          create: `/teams/[team]/syncs/integrations/create`,
          index: `/teams/[team]/syncs/integrations`,
          syncs: `/teams/[team]/syncs/integrations/[name]/syncs`,
          update: `/teams/[team]/syncs/integrations/[name]/update`,
        },
        update: `/teams/[team]/syncs/[name]/update`,
      },
      usage: {
        index: `/teams/[team]/usage`,
      },
    },
    userSettings: {
      index: `/user-settings`,
      invitations: `/user-settings/invitations`,
      mfa: `/user-settings/mfa`,
    },
  },
  platformDocs: {
    index: `${docsBaseUrl}/platform`,
    integrationGuides: {
      aws: `${docsBaseUrl}/platform/integration-guides/aws-onboarding-wizard`,
      awsCur: `${docsBaseUrl}/platform/integration-guides/setting-up-an-awscur-integration`,
      azure: `${docsBaseUrl}/platform/integration-guides/setting-up-an-azure-integration`,
      gcp: `${docsBaseUrl}/platform/integration-guides/setting-up-a-gcp-integration`,
      github: `${docsBaseUrl}/platform/integration-guides/setting-up-a-github-integration`,
      index: `${docsBaseUrl}/platform/integration-guides`,
      k8s: `${docsBaseUrl}/platform/integration-guides/setting-up-a-k8s-integration`,
    },
    privacyPolicy: 'https://www.cloudquery.io/legal/privacy-policy',
    searchSyntax: `${docsBaseUrl}/platform/reference/search-query-syntax`,
    sqlConsole: `${docsBaseUrl}/platform/core-concepts/sql-console`,
    sso: `${docsBaseUrl}/platform/production-deployment/enabling-single-sign-on-sso`,
    termsOfService: 'https://www.cloudquery.io/legal/product-terms-of-service',
  },
  platformMultiTenant: {
    assetInventory: {
      index: `/asset-inventory`,
      syntax: `/asset-inventory/syntax`,
    },
    auth: {
      login: '/auth/login',
    },
    dataPipelines: {
      destinations: {
        create: `/data-pipelines/destinations/create`,
        index: `/data-pipelines/destinations`,
        update: '/data-pipelines/destinations/$name/update',
      },
      integrations: {
        create: `/data-pipelines/integrations/create`,
        index: `/data-pipelines/integrations`,
        syncRuns: `/data-pipelines/integrations/$name/syncs`,
        update: `/data-pipelines/integrations/$name/update`,
      },
    },
    index: '/',
    insights: {
      detail: `/insights/$id`,
      index: `/insights`,
    },
    policies: {
      create: `/policies/create`,
      detail: `/policies/$id`,
      edit: `/policies/$id/edit`,
      index: `/policies`,
    },
    reports: {
      index: `/reports`,
      report: `/reports/$id`,
    },
    settings: {
      account: {
        index: '/settings/account/profile',
        mfa: '/settings/account/mfa',
        profile: '/settings/account/profile',
      },
      organization: {
        apiKeys: '/settings/organization/api-keys',
        auditLogs: '/settings/organization/audit-logs',
        customColumns: '/settings/organization/custom-columns',
        dataManagement: '/settings/organization/data-management',
        dataPermissions: {
          create: '/settings/organization/data-permissions/create',
          edit: '/settings/organization/data-permissions/$id',
          index: '/settings/organization/data-permissions',
        },
        featureFlags: '/settings/organization/feature-flags',
        index: '/settings/organization/settings',
        integrations: '/settings/organization/integrations',
        members: '/settings/organization/members',
        notificationDestinations: {
          index: '/settings/organization/notification-destinations',
          slackAuthRedirect: '/settings/organization/notification-destinations/slack-auth-redirect',
        },
        resourceOwnership: '/settings/organization/resource-ownership',
        roles: {
          create: '/settings/organization/roles/create',
          edit: '/settings/organization/roles/$id',
          index: '/settings/organization/roles',
        },
        settings: '/settings/organization/settings',
        sso: '/settings/organization/sso',
        updates: '/settings/organization/updates',
        users: '/settings/organization/users',
      },
    },
    sqlConsole: {
      index: `/sql-console`,
    },
    usage: {
      index: `/usage`,
    },
    userSettings: {
      index: `/user-settings`,
      invitations: `/user-settings/invitations`,
      mfa: `/user-settings/mfa`,
    },
  },
  serviceHealth: 'https://status.cloudquery.io/',
  threads: 'https://www.threads.net/@cloudqueryio',
  trustCenter: 'https://app.drata.com/trust/cc9ec5bb-5e31-4fe3-9175-362b3ad96c70',
  website: {
    blog: `${websiteBaseUrl}/blog`,
    blogArticle: `${websiteBaseUrl}/blog/[article]`,
    blogAuthor: `${websiteBaseUrl}/authors/[author]`,
    blogCategory: `${websiteBaseUrl}/blog/category/[category]`,
    bugBounty: `${websiteBaseUrl}/bug-bounty`,
    caseStudies: `${websiteBaseUrl}/case-studies`,
    caseStudyDunelmCspm: `${websiteBaseUrl}/blog/dunelm-cloudquery-snowflake-enhance-aws-security`,
    caseStudyHexagon: `${websiteBaseUrl}/blog/how-hexagon-built-an-infrastructure-data-lake`,
    caseStudyReddit: `${websiteBaseUrl}/blog/reddit-cloudquery-case-study`,
    caseStudyRidgeline: `${websiteBaseUrl}/blog/ridgeline-enhanced-saved-money-cloud-security-cloudquery`,
    caseStudySkyhawk: `${websiteBaseUrl}/blog/how-skyhawk-security-powers-their-cyber-security-platform-data-collection-with`,
    caseStudyTempus: `${websiteBaseUrl}/blog/tempus-multi-cloud-asset-inventory`,
    contactUs: `${websiteBaseUrl}/contact-us`,
    dataCouncil2024: `${websiteBaseUrl}/data-council-2024`,
    demo: `${websiteBaseUrl}/demo`,
    download: `${websiteBaseUrl}/download`,
    eventDetails: `${websiteBaseUrl}/events/[type]`,
    events: `${websiteBaseUrl}/events`,
    index: websiteBaseUrl ? `${websiteBaseUrl}` : '/',
    learningCenter: `${websiteBaseUrl}/learning-center`,
    learningCenterArticle: `${websiteBaseUrl}/learning-center/[article]`,
    learningCenterCategory: `${websiteBaseUrl}/learning-center/category/[category]`,
    legal: `${websiteBaseUrl}/legal`,
    legalDocument: `${websiteBaseUrl}/legal/[document]`,
    newsletter: `${websiteBaseUrl}/newsletter`,
    pricing: `${websiteBaseUrl}/pricing`,
    productAutomation: `${websiteBaseUrl}/product/automation`,
    productCloudAssetInventory: `${websiteBaseUrl}/product/cloud-asset-inventory`,
    productCloudOps: `${websiteBaseUrl}/product/cloud-ops`,
    productPolicies: `${websiteBaseUrl}/product/policies`,
    resources: `${websiteBaseUrl}/resources`,
    resourcesType: `${websiteBaseUrl}/resources/[type]`,
    solutionsCaasm: `${websiteBaseUrl}/solutions/caasm`,
    solutionsCloudAssetManagement: `${websiteBaseUrl}/solutions/cloud-asset-management`,
    solutionsCloudCmdb: `${websiteBaseUrl}/solutions/cloud-cmdb`,
    solutionsCspm: `${websiteBaseUrl}/solutions/cspm`,
    solutionsFinOps: `${websiteBaseUrl}/solutions/fin-ops`,
    solutionsPlatformEngineering: `${websiteBaseUrl}/solutions/platform-engineering`,
    unsubscribe: `${websiteBaseUrl}/unsubscribe/[type]`,
  },
  wistia: {
    assetInventory: {
      imgUrl:
        'https://embed-ssl.wistia.com/deliveries/b56ea2490f3e654a4e922c4d5d8b8cdecc711ace.jpg?video_still_time=0',
      sourceUrl: 'https://cloudquery-2.wistia.com/medias/xpqesvfbi1',
    },
    cliAwsToPostgres: {
      imgUrl:
        'https://embed-ssl.wistia.com/deliveries/6dd490cfb8b5b8efd3a0488a4f0bfff659113b77.jpg?video_still_time=0',
      sourceUrl: 'https://cloudquery-2.wistia.com/medias/06dfxqrwkp',
    },
    cloudCmdb: {
      imgUrl:
        'https://embed-ssl.wistia.com/deliveries/58f34b17e387aaba8c20bb6fab32c1be.webp??video_still_time=0',
      sourceUrl: 'https://cloudquery-2.wistia.com/medias/mj228yv5p4',
    },
    cspm: {
      imgUrl:
        'https://embed-ssl.wistia.com/deliveries/d70b1572ba352a103746923dfdc2809a7bf6a6fe.jpg?video_still_time=0',
      sourceUrl: 'https://cloudquery-2.wistia.com/medias/807yn10dvo',
    },
    dataPipelines: {
      imgUrl:
        'https://embed-ssl.wistia.com/deliveries/d75e3c9e03e4bb42f0ff75846cd18bc858e71cf3.webp?video_still_time=0',
      sourceUrl: 'https://cloudquery-2.wistia.com/medias/89j9zk9uy0',
    },
    demo: {
      imgUrl:
        'https://embed-ssl.wistia.com/deliveries/a27d055b6d986f27f58c589c296d67aebe8c45c0.jpg?video_still_time=0',
      sourceUrl: 'https://cloudquery-2.wistia.com/medias/w2nlvnelvk',
    },
    finOps: {
      imgUrl:
        'https://embed-ssl.wistia.com/deliveries/749d80bac2d770f6d8f985e70a098e40584758e4.jpg?video_still_time=0',
      sourceUrl: 'https://cloudquery-2.wistia.com/medias/htqlr4fhzr',
    },
    platformEngineering: {
      imgUrl:
        'https://embed-ssl.wistia.com/deliveries/f3bb0e8f3d8e86f061f3ca5d29059d1d7693fcdf.jpg?video_still_time=0',
      sourceUrl: 'https://cloudquery-2.wistia.com/medias/z0vs0trc6j',
    },
    saveFilters: {
      imgUrl:
        'https://embed-ssl.wistia.com/deliveries/d8b033444a4783cb8761053fa12c7e8c9bb536ab.jpg?video_still_time=0',
      sourceUrl: 'https://cloudquery-2.wistia.com/medias/2n7enpve62',
    },
    sqlConsole: {
      imgUrl:
        'https://embed-ssl.wistia.com/deliveries/8694bbe3c10af6431cc374148667612d62e75269.jpg?video_still_time=0',
      sourceUrl: 'https://cloudquery-2.wistia.com/medias/fixiyi29yp',
    },
  },
  x: 'https://x.com/cloudqueryio',
  youtube: {
    channel: 'https://www.youtube.com/@cloudqueryio',
  },
};
